module.exports = __webpack_public_path__ + "static/Skyway_Automation-ca38c6b238c0ca49dec08e2f03804f23.png";